<table class="edit-info-table">
    <tr>
        <td>Parcel Acct Num:</td>
        <td style="display: flex; gap: 5px;">
            <parcel-icon class="ws-display-inline-block"
                         [parcel]="parcel"
                         [isLinkedParcel]="!!parcel.masterParcelId || !!parcel.subParcelCount"
                         [isMasterParcel]="!parcel.masterParcelId && !!parcel.subParcelCount"
                         propTypeParam="propertyType.propTypeAbbr"
                         size="large"
                         [includeIcons]="true"
                         [ppReturnPreparationAllowed]="ppReturnPreparationAllowed"
                         [stateAllowConsolidating]="stateAllowConsolidating">
            </parcel-icon>
            <input type="text" class="form-control" [(ngModel)]="parcel.acctNum" required="true" maxlength="50">
        </td>
        <td></td>
    </tr>
    @for (acctNum of parcel.altAccountNumbers; track acctNum) {
        @if (shouldDisplayAcctNum(acctNum)) {
            <tr>
                <td>{{ acctNum.accountNumberType.accountNumberDesc }}:</td>
                <td>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="acctNum.acctNumber"
                           required="true"
                           maxlength="50">
                </td>
                <td>
                    <button class="ace-btn has-icon btn-primary btn-danger" (click)="deleteAcctNum(acctNum)">
                        <i class="fa fa-trash"></i>
                    </button>
                </td>
            </tr>
        }
    }
    @if (!(acctNumToAdd || parcel.altAccountNumbers.length === acctNumTypes?.length)) {
        <tr>
            <td></td>
            <td>
                <button class="ace-btn btn-sm btn-primary" type="button" (click)="enterAltAcctNumToAdd()">Add Alternate
                    #
                </button>
            </td>
            <td></td>
        </tr>
    }
    @if (acctNumToAdd) {
        <tr>
            <td></td>
            <td style="display: flex;">
                <select class="form-select form-select-sm" [(ngModel)]="acctNumToAdd.accountNumberTypeID">
                    @for (acctNumType of acctNumTypes; track acctNumType) {
                        @if (!altAcctNumAlreadyAdded(acctNumType)) {
                            <option
                                [ngValue]="acctNumType.accountNumberTypeID">
                                {{ acctNumType.accountNumberDesc }}
                            </option>
                        }
                    }
                </select>
                <input type="text"
                       class="form-control"
                       [(ngModel)]="acctNumToAdd.acctNumber"
                       maxlength="50"
                       required="true">
            </td>
            <td>
                <div style="display: flex; gap: 5px;">
                    <button class="ace-btn has-icon btn-primary" type="button" (click)="addAltAcctNum()">
                        <i class="fa fa-save"></i>
                    </button>
                    <button type="button" class="ace-btn has-icon btn-primary btn-danger" (click)="cancelAddAcctNum()">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
            </td>
        </tr>
    }
    <tr>
        <td>Assessee:</td>
        <td>
            <input type="text" class="form-control" [(ngModel)]="parcel.assesseeName" maxlength="100">
        </td>
        <td></td>
    </tr>
    <tr>
        <td>Desc:</td>
        <td>
            <input type="text" class="form-control" [(ngModel)]="parcel.description" maxlength="50">
        </td>
        <td></td>
    </tr>
    <tr>
        <td style="vertical-align: top; padding-top: 6px;">Address:</td>
        <td>
            <address-view-edit [address]="address"
                               [isEditMode]="true"
                               [isSmall]="true"
                               [readOnlyState]="true"
                               [shouldRestrictExtended]="true">
            </address-view-edit>
        </td>
        <td></td>
    </tr>
    <tr>
        <td>Property Type:</td>
        <td>
            <select class="form-select form-select-sm"
                    style="width: auto"
                    [(ngModel)]="parcel.propertyTypeID"
                    (change)="onPropertyTypeChange()"
                    [disabled]="years?.length && !hasMoveCopyPermission">
                @for (propType of propertyTypes; track propType) {
                    <option [ngValue]="propType.propertyTypeID">{{ propType.propTypeName }}</option>
                }
            </select>
        </td>
        <td></td>
    </tr>
    <tr>
        <td>Assessor:</td>
        <td>
            <select class="form-select form-select-sm"
                    style="width: auto"
                    [(ngModel)]="parcel.assessorID"
                    (change)="onAssessorChanged()"
                    [disabled]="years?.length && !hasMoveCopyPermission"
                    helpTooltip
                    [contentComponent]="assessorDetailsRenderer"
                    [contentComponentValue]="parcelAssessor">
                @for (assessor of assessors; track assessor) {
                    <option [ngValue]="assessor.assessorID">{{ assessor.abbr }} {{ assessor.municipalityName }}</option>
                }
            </select>
        </td>
        <td></td>
    </tr>
    @if (showTaxingDistrict) {
        <tr>
            <td>Taxing District:</td>
            <td>
                @if (parcelAssessor?.taxingDistrictModels.length) {
                    <select
                        class="form-select form-select-sm"
                        style="width: auto"
                        [(ngModel)]="parcel.taxingDistrictId">
                        <option [ngValue]="null"></option>
                        @for (district of parcelAssessor.taxingDistrictModels; track district) {
                            <option [ngValue]="district.taxingDistrictId">{{ district.displayName }}</option>
                        }
                    </select>
                }
                @if (!parcelAssessor?.taxingDistrictModels.length) {
                    <em>No Taxing Districts for this Assessor</em>
                }
            </td>
            <td></td>
        </tr>
    }
    @if (assessmentClasses) {
        <tr>
            <td>Assessment Class(es):</td>
            <td>
                <ws-multi-select class="ws-stretch-width"
                                 labelProperty="name"
                                 [isDropup]="true"
                                 [objectIsValue]="true"
                                 [useSemicolons]="true"
                                 [(ngModel)]="parcel.parcelAssessmentClasses"
                                 [options]="assessmentClasses">
                </ws-multi-select>
            </td>
            <td></td>
        </tr>
    }
    <tr>
        <td style="vertical-align: top; padding-top: 6px;">Collector(s):</td>
        <td>
            @for (collector of nonDeletedParcelCollectors; track collector) {
                <div class="editable-collector">
                    <div style="display: flex; justify-content: space-between;">
                        <span>{{ collector.collectorAbbr }}@if (collector.collectorBillingScenarioName) {
                            <span>- {{ collector.collectorBillingScenarioName }}</span>
                        }</span>
                        <button class="ace-btn has-icon btn-primary btn-danger"
                                (click)="deleteParcelCollector(collector)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                    <div style="display: flex; align-items: center;">
                        <div>Acct Num:</div>
                        <div>
                            <input type="text"
                                   [(ngModel)]="collector.collectorAcctNum"
                                   class="form-control"
                                   maxlength="35">
                        </div>
                    </div>
                    @for (option of collector.parcelCollectorPaymentOptions; track option) {
                        @if (getCollectorPaymentOptionInfo(collector, option)?.length) {
                            <div
                                style="display: flex; align-items: center;">
                                <div>
                                    @if (option.collectorPaymentOption.collectorBillName) {
                                        <span>{{ option.collectorPaymentOption.collectorBillName }} </span>
                                    }Pmt Option:
                                </div>
                                <select class="form-select form-select-sm"
                                        style="width: auto;"
                                        [(ngModel)]="option.collectorPaymentOptionID"
                                        (change)="paymentOptionChanged(option)">
                                    @for (item of getCollectorPaymentOptionInfo(collector, option); track item) {
                                        <option
                                            [ngValue]="item.collectorPaymentOptionID">
                                            {{ item.collectorPaymentOptionName }}
                                        </option>
                                    }
                                </select>
                            </div>
                        }
                    }
                    <div>
                        <collector-tax-rate-area
                            [trs]="getTRS(collector)"
                            [parcelCollector]="collector"
                            [parcel]="parcel"
                            [years]="years"
                            [editMode]="true">
                        </collector-tax-rate-area>
                    </div>
                </div>
            }
            <div>
                <button type="button" class="ace-btn btn-sm btn-primary" (click)="addParcelCollector()">Add Collector
                </button>
            </div>
        </td>
        <td></td>
    </tr>
    <tr>
        <td>Legal Desc:</td>
        <td>{{ parcel.legalDescription?.substring(0, 50) || 'None' }}</td>
        <td>
            <button class="ace-btn has-icon btn-primary" (click)="showLegalDescriptionDialog()">
                <i class="fa fa-pencil"></i>
            </button>
        </td>
    </tr>
    @if (parcel.accrualsEnabled) {
        @if (parcel.accrualsExclude.parentExcludedFromAccruals) {
            <tr>
                <td>Parent Excluded From Accruals</td>
                <td></td>
                <td></td>
            </tr>
        }
        @if (!parcel.accrualsExclude.parentExcludedFromAccruals) {
            <tr>
                <td>Exclude From Accruals:</td>
                <td>
                    <input type="checkbox"
                           [(ngModel)]="parcel.accrualsExclude.excludeFromAccruals">
                </td>
                <td></td>
            </tr>
        }
    }
    <tr>
        <td>Status:</td>
        <td>
            <select class="form-select form-select-sm"
                    [(ngModel)]="parcel.activityStatusID"
                    [popover]="activatedByPopover"
                    triggers="mouseenter:mouseleave"
                    container="body"
                    style="width: auto;">
                @for (option of activityStatuses; track option) {
                    <option [ngValue]="option.activityStatusId">{{ option.status }}</option>
                }
            </select>
        </td>
        <td></td>
    </tr>
    <tr>
        <td>Sold Date:</td>
        <td>
            <weissman-datetime [dateOnly]="true" [(inputDate)]="parcel.transaction.soldDate"></weissman-datetime>
        </td>
    </tr>
</table>
<div style="padding-top: 20px;">
    <button class="ace-btn btn-sm btn-primary btn-danger" (click)="deleteParcel()">Delete</button>
    @if (hasMoveCopyPermission) {
        <button
            class="ace-btn btn-sm btn-primary"
            (click)="goToMoveCopy(true)">
            Move
        </button>
    }
    @if (hasMoveCopyPermission) {
        <button
            class="ace-btn btn-sm btn-primary"
            (click)="goToMoveCopy(false)">
            Copy
        </button>
    }
    @if ((!parcel.masterParcelId) || (parcel.masterParcelId == parcel.parcelID)) {
        <linked-parcels-edit
            [parcelId]="parcel.parcelID"
            [parcelAcctNum]="parcel.acctNum"
            [masterParcelId]="parcel.masterParcelId"
            [masterParcelAcctNum]="parcel.masterParcelAcctNum"
            [linkedParcelCount]="parcel.subParcelCount"
            (linkedParcelsChanged)="linkedParcelsChanged($event)">
        </linked-parcels-edit>
    }
</div>

<ng-template #activatedByPopover>
    @if (parcel.activatedDateTime > parcel.inactivatedDateTime) {
        <div>
            @if (parcel.activatedBy) {
                <div>
                    Activated by {{ parcel.activatedBy }} <br>
                    Date: {{ parcel.activatedDateTime | date:'M/d/YYYY' }}
                </div>
            }
            @if (parcel.inactivatedBy || parcel.inactivatedDateTime) {
                <div style="margin-top: 10px;">
                    Inactivated <span ng-show="parcel.inactivatedBy">by {{ parcel.inactivatedBy }}</span> <br>
                    Date: {{ parcel.inactivatedDateTime | date:'M/d/YYYY' }}
                </div>
            }
        </div>
    }
    @if (parcel.activatedDateTime <= parcel.inactivatedDateTime) {
        <div>
            @if (parcel.inactivatedBy || parcel.inactivatedDateTime) {
                <div style="margin-top: 10px;">
                    Inactivated <span ng-show="parcel.inactivatedBy">by {{ parcel.inactivatedBy }}</span> <br>
                    Date: {{ parcel.inactivatedDateTime | date:'M/d/YYYY' }}
                </div>
            }
            @if (parcel.activatedBy) {
                <div>
                    Activated by {{ parcel.activatedBy }} <br>
                    Date: {{ parcel.activatedDateTime | date:'M/d/YYYY' }}
                </div>
            }
        </div>
    }
</ng-template>
